module.exports = __webpack_public_path__ + "media/couch_sweepstakes/laptop-couch-guy-45207eca.png";